import { render } from "./ModalPaneltyCancel.vue?vue&type=template&id=626c550d&scoped=true"
import script from "./ModalPaneltyCancel.vue?vue&type=script&lang=js"
export * from "./ModalPaneltyCancel.vue?vue&type=script&lang=js"

import "./ModalPaneltyCancel.vue?vue&type=style&index=0&id=626c550d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626c550d"]])

export default __exports__